import React from 'react';
import '../styles/Footer.css'; // Importa el nuevo archivo de estilos
import { lang, getLang } from '../lang';
import { logSocial } from '../config/analytics';
import { Link } from 'react-router-dom';

const routes = {
    es: {
        home: '/',
        projects: '/proyectos',
        team: '/equipo',
        contact: '/contacto'
    },
    en: {
        home: '/en',
        projects: '/en/projects',
        team: '/en/team',
        contact: '/en/contact'
    }
};

const Footer: React.FC = () => {
    const currentLang = getLang();

    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-section">
                    <h3 className="footer-title">{lang.Footer.company}</h3>
                    <ul className="footer-links">
                        <li><Link to={routes[currentLang].team}>{lang.Footer.aboutUs}</Link></li>
                        <li><Link to={routes[currentLang].projects}>{lang.Footer.projects}</Link></li>
                    </ul>
                </div>
                <div className="footer-section">
                    <h3 className="footer-title">{lang.Footer.followUs}</h3>
                    <ul className="footer-social-links">
                        <li>
                            <a 
                                href="https://x.com/TerralTeam" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                onClick={() => logSocial('X', 'Visit', 'Footer')}
                            >
                                x.com
                                <svg className='social-icon' xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="50" height="50" viewBox="0 0 50 50" fill='currentColor'>
                                    <path d="M 11 4 C 7.134 4 4 7.134 4 11 L 4 39 C 4 42.866 7.134 46 11 46 L 39 46 C 42.866 46 46 42.866 46 39 L 46 11 C 46 7.134 42.866 4 39 4 L 11 4 z M 13.085938 13 L 21.023438 13 L 26.660156 21.009766 L 33.5 13 L 36 13 L 27.789062 22.613281 L 37.914062 37 L 29.978516 37 L 23.4375 27.707031 L 15.5 37 L 13 37 L 22.308594 26.103516 L 13.085938 13 z M 16.914062 15 L 31.021484 35 L 34.085938 35 L 19.978516 15 L 16.914062 15 z"></path>
                                </svg>
                            </a>
                        </li>
                        <li>
                            <a 
                                href="https://www.linkedin.com/company/terral-creative-team/" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                onClick={() => logSocial('LinkedIn', 'Visit', 'Footer')}
                            >
                                LinkedIn
                                <svg className='social-icon' xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" fill='currentColor'>
                                    <path fill="#fff" d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"></path>
                                    <path d="M30,37V26.901c0-1.689-0.819-2.698-2.192-2.698c-0.815,0-1.414,0.459-1.779,1.364c-0.017,0.064-0.041,0.325-0.031,1.114L26,37h-7V18h7v1.061C27.022,18.356,28.275,18,29.738,18c4.547,0,7.261,3.093,7.261,8.274L37,37H30z M11,37V18h3.457C12.454,18,11,16.528,11,14.499C11,12.472,12.478,11,14.514,11c2.012,0,3.445,1.431,3.486,3.479C18,16.523,16.521,18,14.485,18H18v19H11z" opacity=".05"></path>
                                    <path d="M30.5,36.5v-9.599c0-1.973-1.031-3.198-2.692-3.198c-1.295,0-1.935,0.912-2.243,1.677c-0.082,0.199-0.071,0.989-0.067,1.326L25.5,36.5h-6v-18h6v1.638c0.795-0.823,2.075-1.638,4.238-1.638c4.233,0,6.761,2.906,6.761,7.774L36.5,36.5H30.5z M11.5,36.5v-18h6v18H11.5z M14.457,17.5c-1.713,0-2.957-1.262-2.957-3.001c0-1.738,1.268-2.999,3.014-2.999c1.724,0,2.951,1.229,2.986,2.989c0,1.749-1.268,3.011-3.015,3.011H14.457z" opacity=".07"></path>
                                    <path fill="#000" d="M12,19h5v17h-5V19z M14.485,17h-0.028C12.965,17,12,15.888,12,14.499C12,13.08,12.995,12,14.514,12c1.521,0,2.458,1.08,2.486,2.499C17,15.887,16.035,17,14.485,17z M36,36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698c-1.501,0-2.313,1.012-2.707,1.99C24.957,25.543,25,26.511,25,27v9h-5V19h5v2.616C25.721,20.5,26.85,19,29.738,19c3.578,0,6.261,2.25,6.261,7.274L36,36L36,36z"></path>
                                </svg>
                            </a>
                        </li>
                        <li>
                            <a 
                                href="https://www.tiktok.com/@terralteam" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                onClick={() => logSocial('TikTok', 'Visit', 'Footer')}
                            >
                                TikTok
                                <svg className='social-icon' xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" fill='currentColor'>
                                    <path d="M41,4H9C6.243,4,4,6.243,4,9v32c0,2.757,2.243,5,5,5h32c2.757,0,5-2.243,5-5V9C46,6.243,43.757,4,41,4z M37.006,22.323c-0.227,0.021-0.457,0.035-0.69,0.035c-2.623,0-4.928-1.349-6.269-3.388c0,5.349,0,11.435,0,11.537c0,4.709-3.818,8.527-8.527,8.527s-8.527-3.818-8.527-8.527s3.818-8.527,8.527-8.527c0.178,0,0.352,0.016,0.527,0.027v4.202c-0.175-0.021-0.347-0.053-0.527-0.053c-2.404,0-4.352,1.948-4.352,4.352s1.948,4.352,4.352,4.352s4.527-1.894,4.527-4.298c0-0.095,0.042-19.594,0.042-19.594h4.016c0.378,3.591,3.277,6.425,6.901,6.685V22.323z"></path>
                                </svg>
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="footer-section">
                    <h3 className="footer-title">{lang.Footer.contact}</h3>
                    <p className="footer-contact-info">{lang.Footer.contactInfo} <a style={{color: '#3c5ec5'}} href="mailto:info.terralteam@gmail.com">info.terralteam@gmail.com</a></p>
                </div>
            </div>
            <div className="footer-bottom">
                <p className="legal-notice">&copy; {new Date().getFullYear()} Terral Team. {lang.Footer.allRights}</p>
                <p className="icons-credit">{lang.Footer.iconsCredit}  
                    <a href='https://icons8.es' target='_blank' rel='noopener noreferrer'> Icons8</a>
                </p>
            </div>
        </footer>
    );
};

export default Footer; 